import { KnowledgePageMeta } from '@this+that/models';

export type PageTree = Map<string | undefined, KnowledgePageMeta[]>;

export function buildPageTree(pages: KnowledgePageMeta[]): PageTree {
  const tree: PageTree = new Map();
  for (const page of pages) {
    const key = page.parentPageId ?? undefined;
    const siblings = tree.get(key) ?? [];
    siblings.push(page);
    tree.set(key, siblings);
  }
  return tree;
}

export function collectDescendantPageIds(
  pages: KnowledgePageMeta[],
  rootId: string,
): Set<string> {
  const tree = buildPageTree(pages);
  const result = new Set<string>([rootId]);
  const queue: string[] = [rootId];
  while (queue.length > 0) {
    const current = queue.shift();
    if (!current) {
      continue;
    }
    for (const child of tree.get(current) ?? []) {
      if (!result.has(child.pageId)) {
        result.add(child.pageId);
        queue.push(child.pageId);
      }
    }
  }
  return result;
}
